import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import type { FC } from "react";

export type HoverCardProps = HoverCardPrimitive.HoverCardProps;

const HoverCard: FC<HoverCardProps> = ({
  openDelay = 200,
  closeDelay = 150,
  ...props
}) => (
  <HoverCardPrimitive.Root
    closeDelay={closeDelay}
    openDelay={openDelay}
    {...props}
  />
);

export default HoverCard;
